var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNote1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.8613 40C80.8613 62.092 62.952 80 40.8613 80C18.7707 80 0.861328 62.092 0.861328 40C0.861328 17.9093 18.7707 0 40.8613 0C62.952 0 80.8613 17.9093 80.8613 40Z",
    fill: "#ECF0F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2513 27.114V57.778C57.2513 60.478 55.062 62.666 52.3633 62.666H29.3607C26.662 62.666 24.4727 60.478 24.4727 57.778V22.222C24.4727 19.522 26.662 17.3327 29.3607 17.3327H45.886H47.2007L57.2513 27.114Z",
    stroke: "#0033A0",
    strokeWidth: 2.308,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0859 17.4111V25.6284C46.0859 27.6871 47.7553 29.3564 49.8153 29.3564H57.2513",
    stroke: "#0033A0",
    strokeWidth: 2.308,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8906 33.8687H38.52H30.8906Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8906 33.8687H38.52",
    stroke: "#0033A0",
    strokeWidth: 2.308,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8906 41.4058H50.8333H30.8906Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8906 41.4058H50.8333",
    stroke: "#0033A0",
    strokeWidth: 2.308,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8906 49.8379H50.8333H30.8906Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8906 49.8379H50.8333",
    stroke: "#0033A0",
    strokeWidth: 2.308,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote1);
export default __webpack_public_path__ + "static/media/note-1.9bf8d07f69dd2aa2a0399bbd1a0dabcc.svg";
export { ForwardRef as ReactComponent };